import { computed } from 'vue'
import useMenuColor from './use-menu-color'

import type { MenuProps } from './menu'

export const useMenuCssVar = (props: MenuProps) => {
  return computed(() => {
    return {
      '--sg-menu-hover-bg-color': useMenuColor(props).value || '',
    }
  })
}
